import React from 'react'

const Team = () => {
  return (
    <>
               {/* <!--Start Page Header--> */}
        <section className="page-header">
            <div className="page-header__bg" style={{backgroundImage: "url(/assets/images/backgrounds/page-header-img1.jpg)"}}>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="page-header__wrapper">
                            <div className="page-header__content">
                                <h2>Our Team</h2>
                                <div className="page-header__menu">
                                    <ul>
                                        <li><a href="/">Home</a></li>
                                        <li>Team</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!--End Page Header--> */}




        {/* <!--Start Team One--> */}
        <section className="team-one team-one--team">
            <div className="container">
                <div className="sec-title text-center">
                    <span className=" sec-title__tagline">Our Team</span>
                    <h2 className="sec-title__title">Our talent Florring Team</h2>
                </div>
                <div className="row">
                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img1.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a href="#">Mahfuz Riad </a></h2>
                                <p>Wood Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}

                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img2.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a href="#">Max Chaoma</a></h2>
                                <p>Floor Carpet Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}

                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img3.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a href="#">Foqrul Islam</a></h2>
                                <p>Wood Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}

                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img4.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a href="#">Al Amin</a></h2>
                                <p>Wood Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}

                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img5.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a href="#">Alan Islam</a></h2>
                                <p>Floor Carpet Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}

                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img6.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a href="#">Mahadi ma</a></h2>
                                <p>Wood Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}
                </div>
            </div>
        </section>
        {/* <!--End Team One--> */}



        {/* <!--Start Best Logistics One--> */}
        <section className="best-logistics-one">
            <div className="shape2 zoominout"><img src="/assets/images/shapes/best-logistics-v1-shape2.png" alt="" /></div>
            <div className="container">
                <div className="row">
                    {/* <!--Start Best Logistics One Content--> */}
                    <div className="col-xl-6">
                        <div className="best-logistics-one__content">
                            <div className="sec-title">
                                <h2 className="sec-title__title">Expert Flooring <br/>Installers</h2>
                                <p className="sec-title__text">There are many variations of passages of Lorem Ipsum
                                    available but the majority have suffered alteration </p>
                            </div>

                            <ul className="best-logistics-one__content-counter">
                                <li className="wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                    <div className="inner">
                                        <h2>
                                            <span className="odometer" data-count="5">00</span><span className="k">k</span><span
                                                className="fa fa-plus plus-icon"></span>
                                        </h2>
                                        <h3 className="best-logistics-one__content-counter-title">Completed Projects</h3>
                                        <p className="best-logistics-one__content-counter-text">5k complete work</p>
                                    </div>
                                </li>

                                <li className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <h2>
                                        <span className="odometer" data-count="30">00</span><span
                                            className="fa fa-plus plus-icon pd-l"></span>
                                    </h2>
                                    <h3 className="best-logistics-one__content-counter-title">Our Expert </h3>
                                    <p className="best-logistics-one__content-counter-text">Expert Flooring worker</p>
                                </li>

                            </ul>


                            <div className="best-logistics-one__content-bottom">
                                <div className="best-logistics-one__content-bottom-text">
                                    <p>We can help you stand out your business</p>
                                </div>

                                <div className="best-logistics-one__content-bottom-btn">
                                    <a href="#" className="thm-btn">Learn More</a>
                                </div>
                            </div>


                        </div>
                    </div>
                    {/* <!--End Best Logistics One Content--> */}

                    {/* <!--Start Best Logistics One Img--> */}
                    <div className="col-xl-6">
                        <div className="best-logistics-one__img">
                            <div className="shape1 zoom-fade"><img src="/assets/images/shapes/best-logistics-v1-shape1.png"
                                    alt="" /></div>

                            <div className="shape3"><img src="/assets/images/shapes/best-logistics-v1-shape2.png" alt="" />
                            </div>
                            <div className="best-logistics-one__img-inner">
                                <img src="/assets/images/resources/best-logistics-v1-img.jpg" alt="" />
                            </div>
                            <div className="overlay-content">
                                <h2>We Are Since 2006 ! Over 200 Awards</h2>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Best Logistics One Img--> */}
                </div>
            </div>
        </section>
        {/* <!--End Best Logistics One--> */}


        {/* <!--Start Video One--> */}
        <section className="video-one video-one--two video-one--two--about video-one--two--about--team">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="video-one__inner text-center"
                            style={{backgroundImage: "url(/assets/images/backgrounds/video-v1-bg.jpg)"}}>
                            <div className="shape1"><img src="/assets/images/shapes/video-v1-shape1.png" alt="" /></div>
                            <h2>A Complete Solution for Your Flooring <br/>Vision.We have done more than 562 <br/>
                                successful projects</h2>
                            <p>Schedule a free case evaluation. Or call us at +88 17 12 48101</p>

                            <div className="video-one__bottom">
                                <div className="text">
                                    <a href="/Portfolio">View all Project</a>
                                </div>
                                <div className="icon">
                                    <a href="https://www.youtube.com/watch?v=8DP4NgupAhI"
                                        className="video-one__btn video-popup">
                                        <span className="icon-play-2"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!--End Video One--> */}

    </>
  )
}

export default Team